import request from '@/utils/request'

let LotteryApi = {
  /*获取数据*/
  getData(data, errorback) {
    return request._post('/shop/plus.lottery.lottery/getlottery', data, errorback);
  },
  /*编辑*/
  EditLottery(data, errorback) {
    return request._post('/shop/plus.lottery.lottery/setting', data, errorback);
  },
  /*列表*/
  recordList(data, errorback) {
    return request._post('/shop/plus.lottery.lottery/record', data, errorback);
  },
  /*列表*/
  recordList(data, errorback) {
    return request._post('/shop/plus.lottery.lottery/record', data, errorback);
  },
  getAward(data, errorback) {
    return request._post('/shop/plus.lottery.lottery/award', data, errorback);
  },
    /*添加抽奖白名单用户ID*/
  addUser(data, errorback) {
    return request._post('/shop/plus.lottery.lottery/addUser', data, errorback);
  },
    /*获取抽奖白名单用户列表*/
    getUser(data, errorback) {
      return request._post('/shop/plus.lottery.lottery/getUser', data, errorback);
    },
     /*删除抽奖白名单用户*/
     delUser(data, errorback) {
      return request._post('/shop/plus.lottery.lottery/delUser', data, errorback);
    },
}

export default LotteryApi;



// WEBPACK FOOTER //
// ./src/api/lottery.js